import classNames from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

export const twMerge = extendTailwindMerge({
  prefix: "tw-",
});

export const cn = (
  ...inputs: (string | undefined | null | boolean | Record<string, boolean>)[]
) => twMerge(classNames(inputs));
